import type { FinancialProduct } from '@interfaces/financialProduct';
import type { Security } from '@ovComponents/3-pattern/securitiesSelectionTable/types';

/** Adds a 0% row per product, ranked after the rows already in the model. */
export const appendSecurityRows = (
  securities: Security[],
  products: FinancialProduct[],
): Security[] => {
  const highestTaxRank = Math.max(0, ...securities.map((s) => s.taxRank ?? 0));

  return [
    ...securities,
    ...products.map(
      (financialProduct, index): Security => ({
        id: `temp-${financialProduct.id}`,
        financialProduct,
        isCashEquivalent: false,
        taxRank: highestTaxRank + index + 1,
        percentage: 0,
      }),
    ),
  ];
};
